import { render } from "./Admin.component.vue?vue&type=template&id=be2406f4&scoped=true"
import script from "./Admin.component.vue?vue&type=script&lang=js"
export * from "./Admin.component.vue?vue&type=script&lang=js"

import "./Admin.component.vue?vue&type=style&index=0&id=be2406f4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be2406f4"]])

export default __exports__